'use client'

import { useEffect } from 'react'
import { useVisitor } from '@/hooks/use-visitor'
import { setGAVisitorId } from '@/lib/analytics'

/**
 * Visitor & UTM Parameter Tracker
 * 
 * Ensures a visitor record is ALWAYS created and persisted to the database,
 * regardless of whether UTM parameters are present.
 * 
 * This component runs on every page to ensure:
 * 1. Visitor tracking is initialized
 * 2. UTM parameters are captured (if present)
 * 3. Visitor records can be linked to users during signup/signin
 * 4. Internal visitor ID is sent to GA4 for data correlation
 * 
 * This is critical for attribution tracking to work properly.
 */
export function UtmTracker() {
  // This hook handles:
  // - Creating/retrieving visitor ID
  // - Persisting visitor to database
  // - Capturing and storing UTM params
  // - Setting the visitor cookie
  const { visitorId } = useVisitor()

  // Send the internal visitor ID to GA4 as a user property
  // This enables correlation between GA4 analytics and internal visitor data
  useEffect(() => {
    if (visitorId) {
      setGAVisitorId(visitorId)
    }
  }, [visitorId])

  // This is a tracking component, it doesn't render anything
  return null
}
